/**
 * PWA Ekran Yönü (Orientation) Yapılandırması
 * 
 * Bu dosyayı değiştirerek uygulamanın ekran yönünü kontrol edebilirsiniz.
 * 
 * Seçenekler:
 * - 'portrait'  : Sadece dikey mod
 * - 'landscape' : Sadece yatay mod
 * - 'any'       : Her iki yön serbest (kilitleme yok)
 * 
 * NOT: Bu ayarı değiştirdikten sonra manifest.json'daki 
 * "orientation" değerini de aynı şekilde güncellemeyi unutmayın!
 */

export const ORIENTATION_CONFIG = {
  // Ekran yönü: 'portrait' | 'landscape' | 'any'
  mode: 'portrait',
  
  // iOS için uyarı mesajını göster (manifest desteklemediği için)
  showWarningOnIOS: true,
  
  // Uyarı mesajları
  messages: {
    portrait: {
      title: 'Lütfen Cihazı Döndürün',
      description: 'Bu uygulama dikey modda daha iyi çalışır.',
      icon: '📱'
    },
    landscape: {
      title: 'Lütfen Cihazı Döndürün',
      description: 'Bu uygulama yatay modda daha iyi çalışır.',
      icon: '📱'
    }
  }
};

/**
 * Hızlı değiştirme için yardımcı fonksiyonlar
 */
export const setPortraitMode = () => {
  ORIENTATION_CONFIG.mode = 'portrait';
};

export const setLandscapeMode = () => {
  ORIENTATION_CONFIG.mode = 'landscape';
};

export const setAnyMode = () => {
  ORIENTATION_CONFIG.mode = 'any';
};

export default ORIENTATION_CONFIG;
